// extracted by mini-css-extract-plugin
module.exports = {"rowWidthTitle":"typography_rowWidthTitle__Xq3T5","rowWidthLabel":"typography_rowWidthLabel__3-TxS","textWhite":"typography_textWhite__2V13f"};